<template>
  <div>
    <div class="subtitle center no_mobile">
      הזן כלים ועזרים לניתוח
    </div>
    <h2 class="subtitle_inner mobile_only">
      הזן כלים ועזרים לניתוח:
    </h2>
    <div class="required-txt" :class="{ center: !isMobile }">
      *כוכבית מסמלת את השדות הנדרשים לבחירה
    </div>

    <div
      v-if="fields && notes"
      class="inner_group bg--white desk_inner_width desk-flex desk-flex--top sanit-form"
    >
      <div
        v-for="field in fields"
        :key="field.name"
        class="add_new_row flex"
        :class="{
          disabled:
            surg.assistant !== 'מביא אסיסטנט' && field.name === 'assistant_name'
        }"
      >
        <div class="add_new_row_col1">
          {{ field.label }}
          <span class="note mobile_only" v-if="field.note">
            {{ field.note }}
          </span>
        </div>
        <div class="add_new_row_col2">
          <div class="input-opacity desk-block">
            <validation-provider
              :name="field.name"
              :rules="field.rules"
              v-slot="{ errors }"
            >
              <select2
                v-if="field.type === 'select'"
                dir="rtl"
                v-model="surg[field.model]"
              >
                <option value="">בחר</option>
                <option
                  v-for="(option, i) in field.options"
                  :key="i"
                  :value="option.value"
                >
                  {{ option.text }}
                </option>
              </select2>
              <input
                v-else-if="field.type === 'input'"
                :type="field.inputType"
                v-model="surg[field.model]"
                :disabled="
                  surg.assistant !== 'מביא אסיסטנט' &&
                    field.name === 'assistant_name'
                "
              />
              <span class="error-message">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <span class="note no_mobile" v-if="field.note">{{ field.note }}</span>
        </div>
      </div>

      <!-- requests -->
      <div class="add_new_row sanit-order">
        <div class="flex step-4-docs-group">
          <div class="add_new_row_col1 w-100">הזמנות</div>
          <div class="add_new_row_col2 w-100">
            <div
              v-for="(request, key) in requests"
              :key="key"
              class="sur_order flex flex--start"
              @click="surg.requests[key] = !surg.requests[key]"
            >
              <a
                class="sur_order_swipe"
                href="javascript:void(0)"
                :class="{ active: surg.requests[key] }"
              >
                <span class="swipe_in ease"></span>
              </a>
              <div class="sur_order_tx">{{ request }}</div>
            </div>
            <div
              class="sur_order flex flex--start"
              @click="surg.pre_surgery_override = !surg.pre_surgery_override"
              :class="{ disabled: surg.start_date }"
            >
              <a
                class="sur_order_swipe"
                href="javascript:void(0)"
                :class="{ active: surg.pre_surgery_override }"
              >
                <span class="swipe_in ease"></span>
              </a>
              <div>
                נדרש טרום ניתוח
                <div
                  v-show="surg.start_date"
                  class="text--20"
                  style="color: rgb(176, 0, 32);"
                >
                  לא ניתן לעריכה לאחר שיבוץ הניתוח
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- notes desktop -->
      <div class="sanit-notes is--fit">
        <div
          v-for="(note, key) in notes"
          :key="key"
          class="add_new_row flex step-4-docs-group"
          style="height: 47%;"
        >
          <div class="add_new_row_col1 w-100">{{ note }}</div>
          <div class="input_area_opcity">
            <textarea
              v-model="surg[key]"
              placeholder="פירוט..."
              autocomplete="off"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <!-- files -->
    <div id="files-container">
      <template v-for="(fileRow, rowIndex) in files">
        <div
          v-if="fileRow.type !== 'ext-imaging-diagnosis' || showResultsFile"
          class="book_surgery toggleContainer desk_inner_width"
          :class="['intro-' + fileRow.type, 'active']"
          :key="fileRow.title"
          :id="'file_' + fileRow.type"
        >
          <a
            class="book_surgery_top flex"
            href="javascript:void(0)"
            onclick="toggle(this)"
          >
            <span
              class="title"
              :class="{
                'flex is--fit desk-flex--between': fileRow.title.includes('*')
              }"
            >
              {{ fileRow.title }}
              (ניתן להוסיף מסמך בסיומת pdf, jpg, png)

              <Tags v-show="fileRow.title.includes('*')" :isRequired="true" />
            </span>
            <span class="plus-wrap flex m-flex--center">
              <span class="plus"></span>
            </span>
          </a>

          <div class="book_surgery_open toggleInner" style="display:block">
            <div
              class="inner_group bg--white desk-no-pad desk-flex desk-flex--top desk-flex--start surg-doc-container"
            >
              <div
                v-if="fileRow.type === 'clinic-confirm-agreement'"
                class="add_new_row flex file_row"
                style="padding: 0;"
              >
                <div class="add_new_row_col1"></div>
                <div class="add_new_row_col2">
                  <div class="input-opacity desk-block">
                    <validation-provider
                      name="clinic-confirm-agreement"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <select2 dir="rtl" v-model="surg.confirm_agreement">
                        <option value="">בחר</option>
                        <option :value="true">
                          המטופל חתם במרפאתי על הסכמה מדעת לפעולה
                        </option>
                        <option :value="false">
                          המטופל יחתום בבית החולים על הסכמה מדעת לפעולה
                        </option>
                      </select2>
                      <span class="error-message">{{ errors[0] }}</span>
                    </validation-provider>
                  </div>
                </div>
              </div>

              <validation-provider
                v-if="
                  fileRow.type !== 'clinic-confirm-agreement' ||
                    (fileRow.type === 'clinic-confirm-agreement' &&
                      surg.confirm_agreement === 'true')
                "
                :name="'file_' + fileRow.type"
                :rules="fileRow.title.includes('*') ? 'required' : ''"
                v-slot="{ errors }"
              >
                <div
                  class="add_new_row_docs m-pt-15 flex flex--start svg-block"
                >
                  <input
                    :for="'file_' + fileRow.type"
                    type="text"
                    v-model="fileRow.files"
                    v-show="false"
                  />
                  <a
                    class="file_item relative flex desk-block"
                    v-for="(file, index) in fileRow.files"
                    href="javascript:void(0)"
                    :key="index"
                    @click="downloadDocument(file.path, file.name)"
                  >
                    <span
                      @click.prevent="removeFile(rowIndex, index)"
                      class="file-remove"
                    >
                      <CloseSvg />
                    </span>
                    <img class="no_mobile" src="/assets/img/svg/ic-file.svg" />
                    <span class="tx_file block">{{ file.name }}</span>
                  </a>
                  <span
                    class="bt_upload relative flex desk-block"
                    @click="addDocuments(fileRow.type)"
                  >
                    <input type="text" />
                    <div class="ic-upload ease">
                      <UploadSvg />
                    </div>
                    <div class="tx_file ease">הוספת מסמך</div>
                  </span>
                </div>
                <span class="error-message">{{ errors[0] }}</span>
              </validation-provider>
              <span
                v-show="
                  fileRow.note &&
                    (fileRow.type !== 'clinic-confirm-agreement' ||
                      (fileRow.type === 'clinic-confirm-agreement' &&
                        surg.confirm_agreement === 'true'))
                "
                class="text--20 mobile_only"
                style="color: #b00020;"
              >
                {{ fileRow.note }}
              </span>
            </div>
            <span
              v-show="
                fileRow.note &&
                  (fileRow.type !== 'clinic-confirm-agreement' ||
                    (fileRow.type === 'clinic-confirm-agreement' &&
                      surg.confirm_agreement === 'true'))
              "
              class="text--20 no_mobile"
              style="color: #b00020;"
            >
              {{ fileRow.note }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import UploadSvg from "@/assets/img/svg/upload.svg";
import AddDocuments from "@/components/Popups/AddDocuments";
import CloseSvg from "@/assets/img/svg/close.svg";
import surgerySelect from "../../../../mixins/surgerySelect.json";
import Tags from "@/components/Dashboard/Surgery/AddSurgery/Tags.vue";
import {
  downloadDocument,
  getSurgeryDocuments
} from "../../../../utilities/download-document";

export default {
  name: "AnalysisTools",
  components: { UploadSvg, CloseSvg, Tags },
  props: {
    surg: { required: true },
    insurance_surgery_temp: { required: true },
    insurance_type: { required: true },
    isMobile: { default: false },
    editSurgery: { default: false }
  },
  data() {
    return {
      surgerySelect,
      fields: null,
      requests: {
        monitoring_request: "נדרש ניטור",
        blood: "הזמנת מוצרי דם",
        icu: "אשפוז בטיפול נמרץ",
        tee_request: "נדרש T.E.E.",
        navigation_request: "נדרש ניווט"
      },
      notes: {
        resources: "משאבים נדרשים",
        notes: "הערות"
      },
      files: [
        {
          type: "clinic-confirm-agreement",
          files: [],
          title: "הסכמה מדעת לפעולה*",
          note: `לתשומת ליבך, ע"פ הנחיות משרד הבריאות, מסמך הסכמה מדעת בתוקף עד 30 יום מיום חתימת המטופל.`
        },
        {
          type: "reference-document",
          files: [],
          title: "סיכום ייעוץ לקראת ניתוח*",
          note:
            "*לאור דרישות קופות החולים וחברות הביטוח, יש לצרף מסמך סיכום ייעוץ המפנה לניתוח."
        },
        {
          type: "ext-imaging-diagnosis",
          files: [],
          title: "פענוח בדיקות הדמייה*",
          note: `ע"פ נהלי הקופה, קוד הניתוח הנבחר מחייב העלאת פענוח בדיקת הדמייה.`
        },
        { type: "", files: [], title: "קבצים נוספים" }
      ]
    };
  },
  computed: {
    showResultsFile() {
      if (this.insurance_type !== "כללית מושלם") return false;
      const codes = [
        "24",
        "25",
        "37",
        "38",
        "130",
        "262",
        "336",
        "414",
        "349",
        "344"
      ];
      return this.insurance_surgery_temp.some(
        i => i.code && codes.includes(i.code.split(" > ")[0])
      );
    },
    surgeryId() {
      return this.editSurgery
        ? this.$route.params.id
        : sessionStorage.getItem("temp_surgery");
    }
  },
  methods: {
    downloadDocument,
    addDocuments(type = null) {
      this.$modal.show(AddDocuments, {
        chosenType: type,
        directUpload: { id: this.surgeryId, type: "surgery" }
      });
    },
    removeFile(index, fileIndex) {
      const file = this.files[index].files[fileIndex];
      this.$API.uploadFile(
        this.surgeryId,
        "cancel",
        file.id,
        file.name,
        [],
        true,
        this.files[index].type
      );

      this.files[index].files.splice(fileIndex, 1);
      this.surg.files = this.files;
    },
    showFileType(type) {
      if (type === "ext-imaging-diagnosis") return this.showResultsFile;
      return true;
    }
  },
  mounted() {
    if (this.surg.files?.length) this.files = this.surg.files;

    // Listen if added documents
    this.$root.$on("uploadSurgFiles", async ev => {
      const resDoc = await getSurgeryDocuments(this.surgeryId);
      resDoc.forEach((doc, i) => {
        this.files[i].files = doc.files;
      });
      this.surg.files = this.files;
    });

    this.fields = [
      {
        label: "אסיסטנט*",
        name: "assistant",
        type: "select",
        model: "assistant",
        options: this.surgerySelect.assistant_status,
        rules: "required",
        note: "בחר צורך באסיסטנט"
      },
      {
        label: "שם האסיסטנט",
        name: "assistant_name",
        type: "input",
        model: "assistant_name",
        inputType: "text"
      },
      {
        label: "ימי אשפוז*",
        name: "hospitalization",
        type: "select",
        model: "hospitalization",
        options: this.surgerySelect.hospitalization,
        rules: "required"
      },
      {
        label: "הרדמה*",
        name: "anesthesia",
        type: "select",
        model: "anesthesia",
        options: this.surgerySelect.anesthesia,
        rules: "required",
        note: "בחר צורך במרדים"
      },
      {
        label: "סוג צילום",
        name: "xray_type",
        type: "select",
        model: "xray_type",
        options: this.surgerySelect.xray_type
      },
      {
        label: "חתך קפוא (FS)",
        name: "select_frozen_cut",
        type: "select",
        model: "select_frozen_cut",
        options: this.surgerySelect.frozen_cut,
        note: "במידה ויש צורך בFS אנא בחר ביחס למועד הניתוח"
      }
    ];
  }
};
</script>
